
<div class="row mx-5">
  <div class="col-12 h1 text-center">
    <div class="h1 text-center fw-bolder mb-1 py-5" style="color: #273C66; font-size: 1.9rem; font-family: 'Poppins', sans-serif; letter-spacing: 2px; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
      Why Choose Us
    </div>
  </div>
</div>

<div class="container">
  <div class="row mb-4 justify-content-center">
    <!-- Insightful Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/insightful-01.svg" class="card-img mx-auto" alt="Insightful">
        <h4 class="card-title mt-3">Insightful</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">Skip all the complex math to the app. Get actionable insights on saving money and improving returns on your investments.</p>
      </div>
    </div>

    <!-- font-family: 'Poppins', sans-serif;
    font-size: 2rem; /* Adjust size as needed */
    font-weight: 900;
    color: #273C66; /* Dark blue primary color */ -->
    <!-- Secure Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/secure-01.svg" class="card-img mx-auto" alt="Secure">
        <h4 class="card-title mt-3">Secure</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">No need for any account details, passwords. Plus, Bank-Level security makes it safe to use.</p>
      </div>
    </div>
    <!-- Real-Time Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/real time-01.svg" class="card-img mx-auto" alt="Real-Time">
        <h4 class="card-title mt-3">Real-Time</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">Your investments' performance is updated real-time so that you don't miss a thing.</p>
      </div>
    </div>
  </div>

  <div class="row mb-5 justify-content-center">
    <!-- Automated Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/automated-01-01.svg" class="card-img mx-auto" alt="Automated">
        <h4 class="card-title mt-3">Automated</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">Enter a completely automated world of managing your money.</p>
      </div>
    </div>
    <!-- Smart Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/smart-01.svg" class="card-img mx-auto" alt="Smart">
        <h4 class="card-title mt-3">Smart</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">Get all your investments neatly organized with zero manual input.</p>
      </div>
    </div>
    <!-- Online Process Card -->
    <div class="col-md-4 mb-5">
      <div class="fancy-card text-center h-100">
        <img src="assets/snp Image/online processs-01.svg" class="card-img mx-auto" alt="Online Process">
        <h4 class="card-title mt-3">Online Process</h4>
        <p class="card-text font-family-sans-serif,poppins, font-size-1.1rem,font-weight-900 ,color:#273C66;">Online & paperless. Automation from investment till withdrawals.</p>
      </div>
    </div>
  </div>
</div>


<!-- About SNP Money Section -->
<div class="container-fluid py-5" style="background-color: #f8f9fa;">
  <div class="row align-items-center">
    <!-- Image on Left -->
    <div class="col-md-6 text-center mb-4 mb-md-0">
      <img src="assets/tf/tf.jpg" alt="Financial Planning" class="wide-rectangle-image img-fluid">
    </div>
    

    <!-- About Us Text -->
    <div class="col-md-6">
      <h2 class="fw-bold" style="color: #273C66; font-family: 'Poppins', sans-serif; font-size: 1.9rem; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
        About SNP Money
      </h2>
      <p style="font-family: 'Poppins', sans-serif; font-size:1.1rem; color: #273C66;">
        <strong>SNP Money</strong> is the brand name of <strong>SNP Wealth Private Limited</strong>, working with individuals and businesses to manage their personal finances and achieve their financial goals such as 
        <strong>Retirement Planning</strong>, <strong>Child Education Planning</strong>, <strong>Investment Planning</strong>, <strong>Tax Optimization</strong>, and <strong>Insurance Planning</strong>.
      </p>
      
     
      
      <a href="aboutUs" style="text-decoration: none;">
        <button style="margin-top: 20px; padding: 10px 20px; font-family: 'Poppins', sans-serif; font-size: 1rem; color: #FFFFFF; background-color: #273C66; border: none; border-radius: 5px; cursor: pointer; ">
          About Us
        </button>
      </a> 
      
    </div>
    
    <div class="container-fluid py-5" style="background-color: #f8f9fb;">
      <div class="row text-center mb-5">
        <div class="col-12">
          <h2 class="fw-bold" style="color: #273C66; font-family: 'Poppins', sans-serif; font-size: 1.9rem; text-decoration: underline; text-decoration-color: red; text-underline-offset: 5px;">
            Our Vision & Mission
          </h2>
          <p style="font-size: 1.2rem; color: #555;">
            Discover our commitment to empowering your financial future.
          </p>
        </div>
      </div>
    
      <div class="row g-4 justify-content-center">
        <!-- Vision Card -->
        <div class="col-md-5">
          <div class="card vision-mission-card shadow-sm h-100" style="border-radius: 10px; transition: transform 0.3s ease;">
            <div class="card-body d-flex flex-column align-items-center text-center p-4">
              <div class="icon-wrapper mb-4">
                <img src="assets\vision\visio.png" alt="Vision Icon" style="width: 50px;">
              </div>
              <h3 class="fw-bold" style="color: #273C66; font-family: 'Poppins', sans-serif; font-size: 1.7rem;">Vision</h3>
              <p style="font-family: 'Poppins', sans-serif; font-size: 1.1rem; color: #555;">
                To become the most trusted Goal-Based Financial Products & Solutions Provider, helping clients achieve financial freedom and wealth creation.
              </p>
            </div>
          </div>
        </div>
    
        <!-- Mission Card -->
        <div class="col-md-5">
          <div class="card vision-mission-card shadow-sm h-100" style="border-radius: 10px; transition: transform 0.3s ease;">
            <div class="card-body d-flex flex-column align-items-center text-center p-4">
              <div class="icon-wrapper mb-4">
                <img src="assets\vision\targe.png" alt="Mission Icon" style="width: 50px;">
              </div>
              <h3 class="fw-bold" style="color: #273C66; font-family: 'Poppins', sans-serif; font-size: 1.7rem;">Mission</h3>
              <p style="font-family: 'Poppins', sans-serif; font-size:1.1rem; color: #555;">
                To help clients achieve their financial freedom and grow wealth through financial planning and innovative financial solutions, provided by a team of financial experts and advisors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>